import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

const AddSafeModule = () => {
    const [date, setDate] = useState('');
    const [images, setImages] = useState([]);
    const [fine, setFine] = useState('');
    const [cash, setCash] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Handle form submission
    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');  // Clear previous error messages

        // Validate if date, images, fine, and cash are provided
        if (!date || images.length === 0 || !fine || !cash) {
            setError('Date, Images, Fine, and Cash are required');
            return;
        }

        // Create FormData and append fields
        const formData = new FormData();
        formData.append('date', date);
        images.forEach((image) => formData.append('images', image));  // Append images as 'images' field
        formData.append('fine', fine);
        formData.append('cash', cash);

        try {
            // Make a POST request to the API to create a Safe Module
            const response = await fetch('https://pbhrm.com/api/safemodule', {
                method: 'POST',
                body: formData,
            });

            const contentType = response.headers.get('Content-Type');
            if (contentType && contentType.includes('application/json')) {
                const data = await response.json();
                if (data.status === 1) {
                    // If the creation is successful, show a success message and navigate to the list page
                    Swal.fire({
                      icon: "success",
                      title: data.message,
                    });
                    navigate('/SafeModuleList'); // Redirect to the list page
                } else {
                    // If the response has an error message, display it
                    setError(data.message);
                }
            } else {
                const errorText = await response.text();
                console.error('Error response:', errorText);
                setError('An unexpected error occurred');
            }
        } catch (error) {
            // Handle network errors or unexpected issues
            console.error('Error creating safe module:', error);
            setError(error.message || 'An error occurred while creating the safe module');
        }
    };

    // Handle file input change (multiple images)
    const handleImageChange = (e) => {
        setImages([...e.target.files]);  // Store selected files in images state
    };

    // Listen for ESC key to go back to the previous page
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                navigate(-1); // Go back one page in history
            }
        };

        // Add event listener for keydown event
        window.addEventListener('keydown', handleEscKey);

        // Clean up event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleEscKey);
        };
    }, [navigate]);

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Safe Module</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Safe Module Form */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Add New Safe Module</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="images" className="form-label">Images</label>
                                        <input
                                            type="file"
                                            id="images"
                                            className="form-control"
                                            multiple
                                            onChange={handleImageChange}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="fine" className="form-label">Fine</label>
                                        <input
                                            type="number"
                                            id="fine"
                                            className="form-control"
                                            value={fine}
                                            onChange={(e) => setFine(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="cash" className="form-label">Cash</label>
                                        <input
                                            type="number"
                                            id="cash"
                                            className="form-control"
                                            value={cash}
                                            onChange={(e) => setCash(e.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <button type="submit" className="btn btn-primary">Add Safe Module</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddSafeModule;
